import Highcharts from 'highcharts';
import { filterByCategory } from "./data.js";

function getResponseTimeData() {
    const categories = [
        'Czas reakcji: liczba zgłoszeń',
        'Czas reakcji: liczba zamkniętych',
        'Czas reakcji: średni czas (dni)'
    ];
    const data = filterByCategory(categories);


    // Filter cities that have the required data
    const validData = data.filter(sm =>
        sm['Czas reakcji: liczba zgłoszeń'] !== undefined &&
        sm['Czas reakcji: liczba zamkniętych'] !== undefined &&
        sm['Czas reakcji: średni czas (dni)'] !== undefined
    );

    validData.forEach(sm => {
        sm.closureRate = Math.round((sm['Czas reakcji: liczba zamkniętych'] / sm['Czas reakcji: liczba zgłoszeń']) * 100 * 10) / 10;
        sm.totalReports = sm['Czas reakcji: liczba zgłoszeń'];
        sm.closedReports = sm['Czas reakcji: liczba zamkniętych'];
        sm.enoughReports = sm.totalReports > 1000
        sm.enoughClosed = sm.closedReports > 100
        sm.valid = sm.enoughReports && sm.enoughClosed
        sm.avgTime = (sm.valid) ? Math.round(Number(sm['Czas reakcji: średni czas (dni)'])) : 0
    });

    // Sort by average time ascending (shortest time first)
    return validData.sort((a, b) => (a.valid ? 0 : 1) - (b.valid ? 0 : 1) || a.avgTime - b.avgTime);
}

export default function chartResponseTime(id) {
    if (!document.getElementById(id)) return;

    const data = getResponseTimeData();
    const categories = data.map(item => item.city);
    const timeData = data.map(item => ({
        y: item.avgTime,
        ...item
    }));

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Średni czas reakcji (od wysłania zgłoszenia do zamknięcia)' },
        subtitle: { text: 'Na podstawie zgłoszeń z aplikacji Uprzejmie Donoszę (2024-2025)' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: 'Dni' },
            min: 0
        },
        legend: { enabled: false },
        tooltip: {
            shared: true,
            useHTML: true,
            formatter: function () {
                const point = this.points[0];
                const cityData = data.find(d => d.city === point.key);
                return `<b>${point.key}</b><br/>` +
                    (point.y > 0 ? `Średni czas: <b>${point.y?.toFixed(0)} dni</b><br/>` : '') +
                    `Zgłoszeń łącznie: ${cityData.totalReports}<br/>` +
                    `Zgłoszeń zamkniętych: ${cityData.closedReports} (${cityData.closureRate.toFixed(0)}%)`;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (!this.options.enoughReports)
                            return 'Za mało zgłoszeń';
                        if (!this.options.enoughClosed)
                            return 'Za mało zamkniętych';
                        return `${this.y} dni`
                    }
                }
            }
        },
        credits: { enabled: false },
        series: [{
            name: 'Średni czas (dni)',
            data: timeData,
            color: '#3498db'
        }]
    });
}
